var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-scroller-item',{attrs:{"item":_vm.item,"active":"","index":_vm.index,"data-index":_vm.index}},[_vm._t("default",null,{"item":_vm.item,"highlight":_vm.highlight,"previousItem":_vm.previousItem,"nextItem":_vm.nextItem})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }